/* eslint-disable complexity */
import config from 'Cloud/config';
import { useSelector } from 'react-redux';
import { isPublicPasswordEnabled } from 'reactApp/appHelpers/featuresHelpers/features/publicPassword';
import { isThemedSharedModalItem } from 'reactApp/appHelpers/featuresHelpers/features/themedPublic';
import { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import { useWeblinkOpened } from 'reactApp/components/SharingWindow/SharingNew/hooks/useWeblinkOpened.hook';
import { getFeaturePublicAutoDeletePromo } from 'reactApp/modules/features/features.selectors';
import { getIntegrationClient } from 'reactApp/modules/integration/integration.selectors';
import { getPublicPin, isOwnPublic as isOwnPublicSelector } from 'reactApp/modules/public/public.selectors';
import { isAutoDeleteEnabled } from 'reactApp/modules/sharedAutoDelete/sharedAutoDelete.selectors';
import { isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import type { RootState } from 'reactApp/store';

import { useItemById } from '../SharingNew/hooks/useItemById.hook';

interface UseFeaturesEnabledProps {
    itemStorage?: EStorageType;
    isPhone?: boolean;
    from: EFrom;
    id: string;
}

export function useFeaturesEnabled({ isPhone, from, itemStorage, id }: UseFeaturesEnabledProps) {
    const item = useItemById(id, itemStorage);
    const { isWeblinkOpened } = useWeblinkOpened(from, Boolean(item?.weblink));
    const isPublic = !!config.get('PUBLIC');
    const isOwnPublic = useSelector((state: RootState) => isPublic && isOwnPublicSelector(state));
    const isOwn = !isPublic || isOwnPublic;
    const { isTutoria } = useSelector(getIntegrationClient);
    const storage = item?.storage || itemStorage;
    const isAlbum = from === EFrom.ALBUMS || storage === EStorageType.albums;
    const isFolder = item?.isFolder;

    const isSharedOrMouted = useSelector((state: RootState) =>
        isFolder ? isMountedOrSharedFolder(state, item) : ({} as ReturnType<typeof isMountedOrSharedFolder>)
    );

    const pin = useSelector((state: RootState) => getPublicPin(state, item?.weblink || ''));

    const isAutodeleteFeatureEnabled = Boolean(useSelector(isAutoDeleteEnabled));
    const isAutodeletePromoFeatureEnabled = Boolean(useSelector(getFeaturePublicAutoDeletePromo));

    const showChangePassword = isWeblinkOpened && (isPublicPasswordEnabled || Boolean(pin)) && !isAlbum && isOwn && isFolder && !isTutoria;

    const showChangeDesign = isWeblinkOpened && isThemedSharedModalItem && !isAlbum && isOwn && isFolder && !isTutoria && !isPhone;

    // Отключаем платную фичу в Тутории
    const showAutoDeleteSettings =
        !isTutoria &&
        isOwn &&
        !isAlbum &&
        isFolder &&
        !isSharedOrMouted.isMounted &&
        (isAutodeleteFeatureEnabled || isAutodeletePromoFeatureEnabled);

    return {
        showChangePassword,
        showChangeDesign,
        showAutoDeleteSettings,
        item,
        isFolder,
        isWeblinkOpened,
        isAutodeleteFeatureEnabled,
        isAutodeletePromoFeatureEnabled,
    } as const;
}
